<mat-card appearance="outlined" class="mat-elevation-z1" [formGroup]="$any(entry)">
  <mat-card-content class="product-supplement__content">
    <div class="flex--column product-supplement__form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'product.wizard.supplement.supplement' | translate }}</mat-label>
        <mat-select formControlName="supplement" data-test="product-supplement__product" [compareWith]="compareSupplement">
          <mat-option *ngFor="let variant of availableVariants" [value]="variant">
            {{ variant.description }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="flex--row flex--gutter flex--align-center" *ngIf="$any(entry)?.controls?.supplement?.value?.description">
        <span class="flex__child">
          {{ 'product.wizard.supplement.min' | translate }}
          {{ $any(entry)?.controls?.supplement?.value?.minimumQuantity | agrNumber: '1.0-4' }}%
        </span>
        <div class="flex__child--auto">
          <mat-slider
            class="product-supplement__quantity"
            [min]="$any(entry)?.controls?.supplement?.value?.minimumQuantity"
            [max]="$any(entry)?.controls?.supplement?.value?.maximumQuantity"
            [step]="$any(entry)?.controls?.supplement?.value?.stepSize"
            showTickMarks
            color="primary"
            discrete
            [displayWith]="formatLabel"
            ><input matSliderThumb formControlName="quantity" />
          </mat-slider>
        </div>
        <span class="flex__child">
          {{ 'product.wizard.supplement.max' | translate }}
          {{ $any(entry)?.controls?.supplement?.value?.maximumQuantity | agrNumber: '1.0-4' }}%
        </span>
      </div>
    </div>

    <ng-container *ngIf="$any(entry)?.controls?.supplement?.value?.description">
      <mat-divider class="spacing--margin-vertical"></mat-divider>
      <div class="product-supplement__stats flex--row flex--gutter flex--align-center spacing--margin-vertical" *ngIf="$any(entry) as group">
        <div class="product-supplement__weight flex__child">
          <div class="text--label">
            {{ 'product.wizard.supplement.selected-weight' | translate }}
          </div>
          <div data-test="product-supplement__supplement-weight">
            {{ ($any(entry)?.controls?.quantity.value / 100) * selectedSkuLine?.quantity | agrNumber: '1.0-4' }}
            {{ 'unit.' + selectedSkuLine?.orderUnit | translate }}
          </div>
        </div>
        <div class="product-supplement__percent flex__child">
          <div class="text--label">{{ 'product.wizard.supplement.percent' | translate }}</div>
          <div data-test="product-supplement__supplement-percentage">{{ $any(entry)?.controls?.quantity.value | agrNumber }}%</div>
        </div>
        <div class="product-supplement__promille flex__child">
          <div class="text--label">
            {{ 'product.wizard.supplement.promille' | translate }}
          </div>
          <div data-test="product-supplement__supplement-promile">{{ $any(entry)?.controls?.quantity.value * 10 | agrNumber }}‰</div>
        </div>
      </div>
    </ng-container>

    <mat-divider class="spacing--margin-vertical"></mat-divider>
  </mat-card-content>
  <mat-card-actions class="product-supplement__actions">
    <div>
      <button mat-button color="warn" (click)="removeEntry(index)" data-test="product-supplement__remove">
        {{ 'product.wizard.supplement.remove' | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
